import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Input } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const AddInstalmentForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, t}) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='paymentDate' component={DateTimeInput} showTime={true} step={1} disabled={isReadonly} horizontal required label={t('PaymentHistory_PaymentDate')} validate={[validators.required]} />
			<Field name='transaction' component={Input} disabled={isReadonly} horizontal required componentClass='textarea' label={t('PaymentHistory_Transaction')} validate={[validators.required]} />			
			<Field name='instalmentAmount' component={Input} disabled={isReadonly} horizontal required label={t('PaymentHistory_InstalmentAmount')} validate={[validators.required, validators.number]} />
		</Form>
	);
};

export default reduxForm({ form: 'addInstalment' })(withTranslation()(AddInstalmentForm));